export const GET_DEAL_DETAILS_DATA = 'GET_DEAL_DETAILS_DATA'
export const SET_DD_RESPONSE = 'SET_DD_RESPONSE'
